<div class="d-flex align-items-center">
  <omgui-profile-bubble [profile]="provider" [size]="componentSize.mediumSmall" class="p-3"></omgui-profile-bubble>
  <div class="provider-detail">
    <h4 class="align-self-baseline fw-bold m-0">{{ provider.displayName }}</h4>
    <p class="fw-bold specialty-text"></p>
  </div>
</div>
